export default __webpack_public_path__ + "static/media/call.0c3a55fd.svg";